module.exports = __webpack_public_path__ + "img/bidDischargeFlow.16316395.gif";